<template>
  <div>
    <b-row>
      <b-col
        cols="9"
        class="mb-1"
      >
        <b-link
          style="font-size: 26px; color: #fff;"
          :to="`/lighting-sub?DeptID=${deptid}`"
        >
          <feather-icon
            style="margin-bottom: 5px;"
            size="34"
            icon="ArrowLeftIcon"
          /> <span style="color: #00FF80;"> ไฟฟ้าส่องสว่าง: </span> {{ waydetail }}
        </b-link>
      </b-col>
      <b-col
        lg="3"
        md="3"
        sm="12"
        class="text-sm-right"
      >
        <span class="mr-1">สถานะปัจจุบัน:</span>
        <toggle-button
          :width="90"
          :height="30"
          :sync="true"
          :value="mode"
          :color="{unchecked: '#FF9E00', checked: '#02093B', disabled: '#29CD21'}"
          :labels="{unchecked: 'กลางวัน', checked: 'กลางคืน'}"
          @change="modeDark($event), $refs.Stat.getStatusSEM(), $refs.Chart.handle(), $refs.Table.getSemDetail()"
        />
        <!-- <span v-if="mode === 0">
          ปัจจุบัน: <feather-icon
            style="margin-bottom: 5px;cursor: pointer; color: dimgrey;"
            size="34"
            icon="SunIcon"
            @click="modeDark(1), $refs.Stat.getStatusSEM(), $refs.Chart.handle(), $refs.Table.getSemDetail()"
          />
        </span>
        <span v-if="mode === 1">
          กลางคืน: <feather-icon
            style="margin-bottom: 5px;cursor: pointer; color: darkorange;"
            size="34"
            icon="MoonIcon"
            @click="modeDark(0), $refs.Stat.getStatusSEM(), $refs.Chart.handle(), $refs.Table.getSemDetail()"
          />
        </span> -->
      </b-col>
    </b-row>
    <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 610px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
      <div>
        <b-row>
          <b-col
            lg="12"
            md="12"
          >
            <l-map
              ref="mymap"
              :zoom="zoom"
              :center="center"
              :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
              @update:zoom="zoomUpdated"
            >
              <l-tile-layer :url="url" />
              <l-marker
                v-for="(marker, index) in markers"
                :key="'marker'+index"
                :ref="'marker'+index"
                :lat-lng="[marker.latitude, marker.longitude]"
                :options="{ autoClose: false, closeOnClick: false }"
                @click="getInfonetvox(marker.pole, marker.devct, marker.devid, marker.devbattery, marker.lastupdate, marker.devstatus)"
              >
                <l-icon
                  v-if="marker.devstatus === 'ปกติ'"
                  :icon-size="[28, 40]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/icons/Markerlighting.svg')"
                />
                <l-icon
                  v-else
                  :icon-size="[28, 40]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/icons/LightingGrey.svg')"
                />
                <l-popup>
                  <div>
                    <b-table
                      style="width: 15rem; font-size:15px;"
                      responsive="sm"
                      :items="itemsNetvox"
                      :fields="fieldss"
                      small
                      stacked
                    />
                  </div>
                </l-popup>
              </l-marker>
              <l-marker
                v-for="(marker, index) in markerKerlink"
                :key="'markerKerlink'+index"
                :ref="'markerKerlink'+index"
                style="z-index: 999;"
                :lat-lng="[marker.lat, marker.long]"
                :options="{ autoClose: false, closeOnClick: false }"
                @click="getInfo(marker.gwno, marker.ipaddress, marker.lastupdate)"
              >
                <l-icon
                  v-if="marker.ISOnline === 'Online'"
                  :icon-size="[90, 70]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/icons/gatewayon.gif')"
                />
                <l-icon
                  v-else
                  :icon-size="[90, 70]"
                  :icon-anchor="[16, 37]"
                  :icon-url="require('@/assets/images/icons/gatewayoff.gif')"
                />
                <l-popup>
                  <div>
                    <b-table
                      style="width: 16rem; font-size:15px;"
                      responsive="sm"
                      :items="itemsInfo"
                      :fields="fieldsKerlink"
                      small
                      stacked
                    />
                  </div>
                </l-popup>
              </l-marker>
            </l-map>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <SEMStatistics ref="Stat" />
    <br>
    <SEMChart ref="Chart" />
    <SEMTable ref="Table" />
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BTable, BCard, BLink,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LIcon, LPopup,
} from 'vue2-leaflet'
import axios from '@axios'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
/* eslint-disable global-require */
import SEMStatistics from './SEMStatistics.vue'
import SEMChart from './SEMChart.vue'
import SEMTable from './SEMTable.vue'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: {
    BRow,
    BCol,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    BTable,
    BCard,
    BLink,
    SEMStatistics,
    SEMChart,
    SEMTable,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 15,
      center: [0, 0],
      waydetail: '',
      type_name: '',
      deptid: '',
      markers: [],
      markerKerlink: [],
      itemsNetvox: [],
      mode: true,
      fields: [
        { key: 'detail', label: 'จุดติดตั้ง:', class: 'text-center' },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      camdesc: '',
      userData: JSON.parse(localStorage.getItem('userData')),
      itemsCount: [],
      fieldss: [
        { key: 'pole', label: 'เสาไฟ:' },
        { key: 'devct', label: 'กระแสไฟ:' },
        { key: 'devstatus', label: 'สถานะ:' },
      ],
      fieldsKerlink: [
        {
          key: 'gwno', label: 'ลำดับ', sortable: true, class: 'text-center',
        },
        {
          key: 'ipaddress', label: 'ipaddress', sortable: true, class: 'text-center',
        },
        {
          key: 'lastupdate', label: 'อัพเดตล่าสุด', sortable: true, class: 'text-center',
        },
      ],
      itemsInfo: [],
    }
  },
  created() {
    this.getMarkerSEM()
    this.getMarkerKerlink()
    this.getStatus()
    this.getCenterSem()
    this.checkModeLighting()
  },
  mounted() {
    const map = this.$refs.mymap.mapObject
    map.addControl(new window.L.Control.Fullscreen())
    this.interval = setInterval(() => {
      this.getMarkerSEM()
      this.getStatus()
      this.getCenterSem()
    }, 300000)
  },
  methods: {
    checkModeLighting() {
      axios
        .post('/checkModeLighting', {
          wid: this.$route.query.wid,
        })
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.mode = response.data[0].light_mode
        })
        .catch(error => {
          console.log(error)
        })
    },
    modeDark(val) {
      this.mode = val.value
      axios
        .post('/setModeLighting', {
          mode: val.value, wid: this.$route.query.wid,
        })
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.getMarkerSEM()
        })
        .catch(error => {
          console.log(error)
        })
    },
    zoomUpdated(value) {
      setTimeout(() => axios
        .post('/updateMapZoom', {
          mapzoom: value, wid: this.$route.query.wid, type_name: this.type_name,
        })
        // eslint-disable-next-line no-unused-vars
        .then(response => {
        })
        .catch(error => {
          console.log(error)
        }), 1000)
    },
    getCenterSem() {
      axios
        .post('/waySEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.deptid = response.data[0].deptid
          this.type_name = response.data[0].type_name
          this.zoom = response.data[0].mapzoom
        })
        .catch(error => {
          console.log(error)
        })
    },
    getMarkerSEM() {
      axios
        .post('/getMarkerSEM', { wid: this.$route.query.wid })
        .then(response => {
          this.markers = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getMarkerKerlink() {
      axios
        .post('/modalLoraWan', { wid: this.$route.query.wid })
        .then(response => {
          this.markerKerlink = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getStatus() {
      axios
        .post('/getStatusSEM', { wid: this.$route.query.wid })
        .then(response => {
          this.center.splice(0)
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
          this.waydetail = response.data[0].detail
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInfoCount(wid, detail, way) {
      this.itemsCount = []
      this.itemsCount.push({
        wid,
        detail,
        way,
      })
    },
    getInfo(gwno, ipaddress, lastupdate) {
      this.itemsInfo.splice(0)
      this.itemsInfo.push({
        gwno,
        ipaddress,
        lastupdate,
      })
    },
    getInfonetvox(pole, devct, devid, devbattery, lastupdate, devstatus) {
      console.log(pole)
      this.itemsNetvox = []
      this.itemsNetvox.push({
        pole,
        devct,
        devid,
        devbattery,
        lastupdate,
        devstatus,
      })
    },
  },
}
</script>

<style lang="scss">

  .vue2leaflet-map {
      &.leaflet-container{
      width: 100%;
      height: 568px;
      }
  }
  .leaflet-popup-content {
    margin: 10px 10px;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    background: rgba(36, 36, 36, 0.85);
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
    /* Green */
    border: 1px solid #00B058;
    border-radius: 12px 12px 12px 12px;
}
.v-switch-label{
  font-size: 14px;
}
</style>
